import FetchResponses from "../../../models/FetchResponses";
import React, { Component } from "react";
import settings from "../../../settings";
import PageLoader from "../../GlobalComponents/PageLoader";

class LoginParams extends Component {
  constructor(props) {
    super(props);
    this.state = {
      loading: false,
      parameters: {
        title: "",
        content: "",
        imagen: "",
        data: {
          toggle: {
            google: false,
            facebook: false,
          },
        },
      },
    };
  }

  componentDidMount() {
    this.getLoginParams();
  }

  getLoginParams = async () => {
    let url = settings.backend.generalParameters + 1 + "/";
    this.setState({loading: true})
    fetch(url, {
      method: "GET",
      headers: settings.headers_super_auth,
    })
      .then(FetchResponses.processResponse)
      .then((response) => {
        this.setState({ parameters: response });
        this.setState({loading: false})
      })
      .catch(this.failureLogin);
  };

  saveCard = (event) => {
    event.preventDefault();
    this.setState({loading: true})
    let url = settings.backend.generalParameters + 1 + "/";
    fetch(url, {
      method: "PUT",
      headers: settings.headers_super_auth,
      body: JSON.stringify(this.state.parameters),
    })
      .then(FetchResponses.processResponse)
      .then((response) => {
        this.getLoginParams();
      })
      .catch(this.failureLogin);
  };

  handleInputChange = (event) => {
    const { id, value, checked } = event.target;
    const isToggle = id === "facebook" || id === "google";
    const valueSave = isToggle ? checked : value;

    this.setState((prevState) => {
      if (isToggle) {
        return {
          parameters: {
            ...prevState.parameters,
            data: {
              ...prevState.parameters.data,
              toggle: {
                ...prevState.parameters.data.toggle,
                [id]: valueSave,
              },
            },
          },
        };
      } else {
        return {
          parameters: {
            ...prevState.parameters,
            [id]: valueSave,
          },
        };
      }
    });
  };

  render() {
    let { parameters } = this.state;
    return (
      <>
        <form className="form-edit-cards" onSubmit={this.saveCard}>
          <div>
            <span className="carrusel--subtitle">Titulo</span>
            <input
              type="text"
              className="form-control"
              //readOnly
              value={parameters.title}
              onChange={this.handleInputChange}
              field="title"
              id="title"
              placeholder="Titulo"
              required
            />
          </div>

          <div>
            <span className="carrusel--subtitle">Descripción</span>
            <input
              type="text"
              className="form-control"
              onChange={this.handleInputChange}
              //readOnly
              value={parameters.content}
              field="content"
              placeholder="Descripcion"
              id="content"
              required
            />
          </div>

          <div>
            <span className="carrusel--subtitle">Imagen</span>
            <input
              type="text"
              className="form-control"
              onChange={this.handleInputChange}
              //readOnly
              value={parameters.imagen}
              field="imagen"
              id="imagen"
              placeholder="imagen"
              required
            />
          </div>

          <label className="carrusel--subtitle">Google</label>
          <div className="form-check form-switch m-0">
            <input
              className="form-check-input"
              type="checkbox"
              role="switch"
              id={`google`}
              checked={parameters.data.toggle.google}
              style={{
                transform: "scale(1.3)",
                cursor: "pointer",
                backgroundColor: parameters.data.toggle.google ? "#a00" : "",
                borderColor: parameters.data.toggle.google ? "#a00" : "",
              }}
              onChange={this.handleInputChange}
            />
          </div>

          <label className="carrusel--subtitle">Facebook</label>
          <div className="form-check form-switch m-0">
            <input
              className="form-check-input"
              type="checkbox"
              role="switch"
              id={`facebook`}
              checked={parameters.data.toggle.facebook}
              style={{
                transform: "scale(1.3)",
                cursor: "pointer",
                backgroundColor: parameters.data.toggle.facebook ? "#a00" : "",
                borderColor: parameters.data.toggle.facebook ? "#a00" : "",
              }}
              onChange={this.handleInputChange}
            />
          </div>

          <div className="form-edit-cards-buttons">
            <button
              className="btn btn-primary"
              style={{ background: "#a00", borderColor: "#a00" }}
              type="submit"
            >
              Guardar
            </button>
          </div>
        </form>

        {this.state.loading && <PageLoader />}
      </>
    );
  }
}

export default LoginParams;
